<template>
    <div ref="container" class='position-relative h-100'>

        <loading ref="loading"></loading>

        <smsp-search-dialog ref='smspSearchDialog' v-on:copy='populateUser'></smsp-search-dialog>

            <div class="card d-flex flex-column h-100">

                <header class="list-header" style="z-index: 100;">
                    <h2 class="h4 p-2 mb-0 header__dashboard--top">{{formTitle()}}&nbsp;</h2>
                </header>

        		<div ref="editScroller" class="card-body pt-2 flex-grow-1-scroll">
                    <local-error v-bind:errors='errors' v-bind:inline='inline_errors'></local-error>

                    <component 
                        :title='title' 
                        v-model='item'
                        v-bind:event='event'
                        v-bind:type='type'
                        v-bind:is='displayelement' 
                        v-bind:route='route' 
                        v-bind:model='model' 
                        v-bind:originalData.sync='originalData'
                        ref='subComponent' />
                    
        		</div>

                <footer class='container-footer'>
                    <button v-if='type == "edit"' class="btn btn-success btn-round" v-on:click.prevent='updateItem' role="button">{{ $t('translations.update')}}</button>
                    <button v-else class="btn btn-success btn-round" v-on:click.prevent='createItem' role="button">{{ $t('translations.create')}}</button>

                    <button v-if='this.event == "patient"' class="btn btn-success btn-round" v-on:click.prevent='$refs.smspSearchDialog.showSmspSearchDialog(item)' role="button">{{ $t('translations.spine_lookup')}}</button>

                    <button class="btn btn-round btn-warning mr-1" v-on:click.prevent='cancelEdit()' role="button">{{ $t('translations.cancel')}}</button>
                    <button v-if='canDelete()' class="btn btn-danger btn-round mr-1 float-right" role="button" v-on:click.prevent='deleteItem'>{{ $t('translations.delete')}}</button>
                </footer>

            </div>
    </div>
</template>


<script>
	export default {
		props: {
			'route': {},
            'event': {},
			'model': {},
			'elementname': {},
            'displayelement': {},
            'type': {},
            'title': {default: null},
		},
		data: function(){
			return {
				item: {name: "", email: "", provider: {name: ""}, usersusergroup: []},
                related_data: {},
                errors: [],
                inline_errors: [],
                testing: "TEST",
                originalData: {},
			};
		},
        computed: {
            // formTitle() {
            //     if(this.type == "edit") {
            //         return this.getName();
            //     }
            //     else if(this.type == "create") {
            //         return this.$t('translations.create_new') +" " + this.tBrandKey(this.elementname);
            //     }
            //     else return "&nbsp;"
            // }
        },
        mounted() {

            this.errors = [];
            this.resetItem();

            this.setLoading(true);

            axios.get(this.route + '/relatedData').then((res) => {
                this.related_data = res.data;

                if(this.type == "edit") {
                    if(this.$route.params.pid) {
                        this.loadItem(this.$route.params.pid);
                    }
                    else if(this.$route.params.id) {
                        this.loadItem(this.$route.params.id);
                    }
                    else {
                        this.loadItem(this.$root.user.id);
                    }
                }
                else if(this.type == "create") {
                    this.resetItem();
                    this.setLoading(false);
                }
            });
        },
        beforeRouteUpdate (to, from, next) {
            this.checkRouteChange(to, from, next);
        },
        beforeRouteLeave(to, from, next) {
            this.checkRouteChange(to, from, next);
        },
		methods: {
            checkRouteChange(to, from, next) {
                this.checkUnsaved(this.originalData, this.item, to, from, next);
            },
            resetItem() {
                if(this.$refs.subComponent.resetItem) {
                    this.$refs.subComponent.resetItem();
                }
                else {
                    this.item = {id: "", name: "", email: "", provider_id: "", users: []};
                }
                this.errors = [];
                this.originalData = JSON.parse(JSON.stringify(this.item));
            },

			loadItem(id) {
                if(this.$refs.subComponent.loadItem) {
                    this.$refs.subComponent.loadItem(id);
                }
                else {
                    this.setLoading(true);
                    axios.get(this.route + '/' + id ).then((res) => {
                        this.item = res.data[this.model];
                        this.originalData = JSON.parse(JSON.stringify(this.item));
                        this.setLoading(false);
    				}).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                        this.$router.push({path: "/" + this.event + "-list"});
                    });
                }
            },
            isInline() {
                return this.$route.fullPath.includes("/patient-inline-edit/");
            },
            closePanel(change) {
                if(this.$router.currentRoute.name == "StaffProfile") {
                    this.$router.push({name: "Dashboard"});
                }
                else if(this.isInline()) {
                    this.$router.push({path: this.$route.fullPath.replace(/\/patient-inline-edit.*/, "")});
                }
                else {
                    if(change) {
                        if(this.$parent.getResults) {
                            this.$parent.getResults();
                        }
                    }
                    //alert(this.item.id);
                    if(this.item.id) {
                        this.$router.push({path: "/" + this.event + "-list/" + this.event + "-show/" + this.item.id});
                    }
                    else {
                        this.$router.push({path: "/" + this.event + "-list"});
                    }
                }
            },
            getName() {
                if(this.$refs.subComponent && this.$refs.subComponent.getName) {
                    return this.$refs.subComponent.getName();
                }
                else {
                    return this.item.name;
                }
            },
            deleteItem(event) {
                if(this.$refs.subComponent && this.$refs.subComponent.deleteItem) {
                    return this.$refs.subComponent.deleteItem();
                }
                else {
                    this.$modal.show('dialog', {
                        title: 'Delete ' + this.tBrandKey(this.elementname),
                        text: "You are about to delete " + this.tBrandKey(this.elementname).toLowerCase() + " " + this.getName() + ". " + this.$t('translations.are_you_sure_you_want_to_continue'),
                        buttons: [
                        {
                            title: 'Yes',
                            handler: () => {
                                this.$modal.hide('dialog');
                                this.setLoading(true);
                                axios.delete(this.route + '/' + this.item.id).then((res) => {
                                    console.log(res.data);
                                    this.setLoading(false);
                                    this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " " + this.$t('translations.notification_deleted_successfully') + "."});
                                    this.item.id = null;
                                    this.originalData = null;
                                    this.closePanel(true);
                                }).catch((error) => {
                                    this.setLoading(false);
                                    this.handleError(error, "delete");
                                });
                            },
                        },
                        {
                            title: 'Cancel',
                            default: true
                        }]});
                }
            },
            updateItem(event) {
                if(this.$refs.subComponent.updateItem) {
                    this.$refs.subComponent.updateItem();
                }
                else {
                    this.setLoading(true);
                    axios.put(this.route + '/' + this.item.id, this.item).then((res) => {
    					//console.log(res.data);
    					this.setLoading(false);
                        this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " " + this.$t('translations.notification_updated_successfully') + "."});
                        this.originalData = null;
    					this.closePanel(true);
    				}).catch((error) => {
                        console.log("error: " + JSON.stringify(error, null, 2));
                        this.setLoading(false);
                        this.handleError(error, "update", this.event + "-list");
                        console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                        this.$refs.editScroller.scrollTop = 0;
                        console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    });
                }
            },

            createItem(event) {
                if(this.$refs.subComponent.createItem) {
                    this.$refs.subComponent.createItem();
                }
                else {
                    this.setLoading(true);
                    axios.post(this.route, this.item).then((res) => {
    					this.setLoading(false);

                        this.addNotification({type: "success", content: this.tBrandKey(this.elementname) + " " + this.getName() + " " + this.$t('translations.notification_created_successfully') + "."});
                        this.item.id = res.data.id;
                        this.originalData = null;
                        this.closePanel(true);
    				}).catch((error) => {
                        this.setLoading(false);
                        this.handleError(error, "create");
                        console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                        this.$refs.editScroller.scrollTop = 0;
                        console.log("this.$refs.editScroller.scrollTop: " + this.$refs.editScroller.scrollTop);
                    });
                }
            },
            
            populateUser(event) {
                function doCopy(item) {
                    return event.copy_items.indexOf(item) != -1;
                }
                console.log(event);
                if(doCopy("nhs_number")) {
                    this.item.nhs_number = this.formatNhsNumber(event.result.user.nhs_number);
                }

                if(doCopy("forenames")) {
                    this.item.forenames = event.result.user.forenames;
                }
                if(doCopy("surname")) {
                    this.item.surname = event.result.user.surname;
                }
                if(doCopy("dob")) {
                    this.item.dob = event.result.user.dob;
                }
                // if(event.result.user.dob) {
                //     this.item.dob = event.result.user.dob.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})$/, "$1-$2-$3");
                // }

                if(doCopy("title")) {
                    var user_title_id = this.$root.lookup.user_titles.getIndex(event.result.user.title.toLowerCase());
                    if(user_title_id !== -1) {
                        this.item.user_title_id = user_title_id;
                    }
                    else {
                        this.item.user_title_id = "";
                    }
                }
                if(doCopy("gender")) {
                    switch(event.result.user.gender) {
                        case "1": this.item.gender = 'm'; break;
                        case "2": this.item.gender = 'f'; break;
                        default: this.item.gender = ''; break;
                    }
                }

                if(doCopy("phone_number")) {
                    if(event.result.user.phone && event.result.user.phone["USE"]) {
                        this.item.phone_number = event.result.user.phone["USE"];
                    }
                }

                if(doCopy("email")) {
                    if(event.result.user.email && event.result.user.email["USE"]) {
                        this.item.email = event.result.user.email["USE"];
                    }
                }

                
                if(event.result.user.address && event.result.user.address["USE"]) {
                    // NOTE: The address lines are indexed from 0 in SPINE, that's why the below looks
                    // confusing.
                    if(doCopy("address_line_1")) {
                        this.item.address_line_1 = event.result.user.address["USE"].address_line_0;
                    }
                    if(doCopy("address_line_2")) {
                        this.item.address_line_2 = event.result.user.address["USE"].address_line_1;
                    }
                    if(doCopy("address_line_3")) {
                        this.item.address_line_3 = event.result.user.address["USE"].address_line_2;
                    }
                    if(doCopy("address_line_4")) {
                        this.item.address_line_4 = event.result.user.address["USE"].address_line_3;
                    }
                    // We don't have an address_line_5 to store this unfortunately
                    // if(doCopy("address_line_5")) {
                    //     this.item.address_line_5 = event.result.user.address["USE"].address_line_4;
                    // }
                    if(doCopy("postcode")) {
                        this.item.postcode = event.result.user.address["USE"].postcode;
                    }
                }
                // else {
                //     this.item.address_line_1 =
                //     this.item.address_line_2 =
                //     this.item.address_line_3 =
                //     this.item.address_line_4 =
                //     this.item.address_line_5 =
                //     this.item.postcode = "";
                // }

                if(this.item.verification_status_id < 2) {
                    this.item.verification_status_id = 2;
                }
                //console.log(event.result.user.forenames);
            },
            cancelEdit() {
                this.originalData = null;
                this.closePanel(false);
            },
            canDelete() {
                if(this.type == "edit" && this.item && this.item.id) {
                    //this.$root.user.id != item.id && type == "edit" && (!is_network_admin() || !this.$parent.event == "staff")
                    if(this.event == "staff") {
                        // Can't delete your own user.
                        if(this.$root.user.id == this.item.id) {
                            return false;
                        }
                        // Can't delete multi-provider users if you are a network admin
                        if(this.is_network_admin() && (Array.isArray(this.item.user_provider) && this.item.user_provider.length != 1)) {
                            return false;
                        }
                    }
                    if(!this.isInline()) {
                        return true;
                    }
                }
                return false;
            },
            formTitle() {
                if(this.type == "edit") {
                    return this.getName();
                }
                else if(this.type == "create") {
                    return this.$t('translations.create_new') +" " + this.tBrandKey(this.elementname);
                }
                else return "&nbsp;"
            },
        }
    }
</script>
